<template>
<b-navbar
  toggleable="lg"
  type="dark"
  variant="info"
  :class="['bg-warning', { embedded: this.isEmbed, 'screen-lg': this.onTabletUp }]"
  v-if="this.currentUser"
>
  <b-row>
    <b-col cols="12" class="d-flex">
      <!-- TODO: Might enable for desktop/web users -->
      <!-- <b-navbar-brand href="#">
        <router-link :to="{ name: 'profile' }">
          <div class="logo">
            <img :src="clientProfileLogo[loggedIn ? currentUser.client.name : '']" />
          </div>
        </router-link>
      </b-navbar-brand> -->
      <b-navbar-nav>
        <PrimaryNavItems v-for="item in primaryNavItems" :key="item.title" :items="primaryNavItems" :item="item" v-if="currentUser" />

        <!-- TODO: Might enable for desktop/web users -->
        <!-- <router-link :to="{ name: 'embed' }">Calendar</router-link>
        <router-link :to="{ name: 'recipes' }">Recipies</router-link>
        <router-link :to="{ name: 'plans' }">Plans</router-link> -->
      </b-navbar-nav>
    </b-col>

    <!-- TODO: Might enable for desktop/web users -->
    <!-- <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
    <b-col cols="10" class="d-flex">
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <router-link :to="{ name: 'home' }">
            Planning
          </router-link>
          <router-link :to="{ name: 'home' }">
            Recipies
          </router-link>
          <router-link :to="{ name: 'home' }">
            Grocery Shopping
          </router-link>
          <router-link :to="{ name: 'home' }">
            Kitchens
          </router-link>
          <BaseButton type="button" class="btn-browse">
            <span>Browse PlateLists</span>
          </BaseButton>
        </b-navbar-nav>
      </b-collapse>
    </b-col> -->
  </b-row>
</b-navbar>
</template>

<script>
import store from '@state/store';
import environment from '@src/environment';
import { authComputed, mainComputed } from '@state/helpers';
import { primaryNavItemMixin } from 'primaryNavItemMixin';
import PrimaryNavItems from './PrimaryNavItems';

export default {
  mixins: [primaryNavItemMixin],
  components: {
    PrimaryNavItems,
  },
  props: {
    isEmbed: {
      type: Boolean,
    },
    onTabletUp: {
      type: Boolean,
    },
  },
  data() {
    return {
      profileOptions: {
        profileRoute: {
          name: 'profile',
          title: () => (this.currentUser ? this.currentUser.user.username : undefined),
        },
        logoutRoute: {
          name: 'logout',
          title: 'Log out',
        },
        loginRoute: {
          name: 'login',
          title: 'Log in',
        },
        homeRoute: {
          name: 'home',
          title: 'Home Page',
        },
      },
    };
  },
  computed: {
    ...authComputed,
    ...mainComputed,
    primaryNavItems() {
      return this.getPrimaryNavItems();
    },
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import 'theme.scss';

.navbar {
  background-color: $color-navbar-bg !important;
  height: 6rem;
  padding: 0.5rem 3rem;

  .logo img {
    margin: 1rem auto;
    width: 75%;
  }

  .navbar-nav {
    flex-direction: row;
  }

  &.embedded,
  &.screen-lg {
    z-index: 2;
  }

  &.screen-lg {
    padding-bottom: 1rem;
    padding-top: 1rem;
  }
}
</style>
